import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { Icon, Tooltip } from 'antd';
import { withTranslation } from 'react-i18next';
import { SidebarMenuWrapper, SettingsCloseButton } from './styles';
import { Logo, AppLogo, MenuTabs, TabsContainer, TabDetails, TabIcon, SideBarContent, SidebarCloseMenu,
  TabsActivityContainer, TabsActivityHighlighter, TabExpandContainer, TabMenuContainer } from '../SidebarMenu/styles';
import ExitIcon from '../../images/exit.svg';
import { DocStudioLogo } from '../../components/SidebarMenuIcons';
import EditorElement from '../../components/EditorElement';
import LetsDesignTabDetails from './LetsDesignTabDetails';
import UploadsTabDetails from '../SidebarMenu/UploadsTabdetails';
import CreativeElementsTabDetails from './CreativeElementsTabDetails';
import TranslateTab from './TranslateTab';
import ComplexDocumentName from './ComplexDocumentName';
import { ComplexDesignTabs, CreativeDesignTabs } from './sidebarTabs';
import { useArtboardContext, CONTEXT_KEYS , TEMPLATE_TYPE} from '../../context/complexArtboardContext';
import { useDocumentContext , COMPLEX_DOCUMENT_CONTEXT_KEYS} from '../../context/complexDocumentContext';
import ComplexDocumentVariableList from './ComplexDocumentVariableList';
import ComplexDocumentAccessibilityValidator from './ComplexDocumentAccessibilityValidator';
import ComplexSettingsTab from './SettingsTab/ComplexSettingsTab';
import DocumentSettingsTab from './SettingsTab/DocumentSettingsTab';
import ComplexElementsTab from './ComplexElementsTab';
import ComplexTemplateTab from './ComplexTemplateTab';
import ComplexFolderTab from './ComplexFolderTab';
import MasterElementsTabDetails from '../SidebarMenu/MasterElementsTabDetails';
import { DESIGN_AREA_SIDEBAR_MENUS ,COMPLEX_DOC_LOGO_HEADER } from '../SidebarMenu/translationValues';
import { COMPLEX_DOCUMENT_VERSION, dummyCallback } from '../../utils/complexDocumentConstants';
import BusinessLogicTab from './BusinessLogicTab';
import ChannelTab from './ChannelTab/CommunicationTab';
import { useSessionContext } from '../../context/sessionContext';
import { BusinessLogic } from '../../context/businessLogicContext';
import { useEmbedding } from '../../context/embedContext';
import { checkUserAccessRoles } from '../../utils/helper';
import { useVersionContext, VERSION_CONTEXT_KEYS } from '../../context/complexVersionContext';
import { useShowVersionSettings } from './VersionSettings/useShowVersionSettings';
import { VersionSettingsSidebar } from './VersionSettings/VersionSettingsSidebar';

const DEFAULT_TAB_INDEX = 2;
const DEFAULT_CREATIVE_TAB_INDEX = 6;
const DEFAULT_REUSABLE_BLOCK_INDEX = 7;
const PREVIEW_AND_DOWNLOAD_TAB = 10;
const premiumTabs = [13, 15];

const NAMESPACES = ['COMPLEX_DOC_SIDEBAR', 'DESIGN_AREA_SIDEBAR_MENUS' , "COMPLEX_DOC_LOGO_HEADER"];
const ComplexArtboardSidebar = ({ t }) => {
  const { embedState } = useEmbedding();
  const [{ currentPageUUID, hideSideBar, isCreativeDesign, currentBlock, editable, currentBlockType }, updateArtboard] = useArtboardContext(store => ({
    currentPageUUID: store[CONTEXT_KEYS.CURRENT_PAGE],
    hideSideBar: store[CONTEXT_KEYS.PAGE_LAYOUT_VISIBLE] || store[CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE] || store[CONTEXT_KEYS.BLOCK_SETTINGS_VISIBLE],
    isCreativeDesign: store[CONTEXT_KEYS.SWITCH_CREATIVE_DESIGN_MENU],
    currentBlock: store[CONTEXT_KEYS.CURRENT_BLOCK],
    editable: store[CONTEXT_KEYS.ENABLE_EDITABLE_DESIGN],
    currentBlockType: store[CONTEXT_KEYS.CURRENT_BLOCK_TYPE]
  }), 'ComplexArtboardSidebar');

  const customSelector = useCallback(store => {
    if (currentBlock && currentBlock !== '' && currentPageUUID && currentPageUUID !== '') {
      const pageWidth = store[currentPageUUID]?.width;
      const pageHeight = store[currentPageUUID]?.height;
      const size = {
        widthInPX: pageWidth,
        heightInPX: pageHeight
      };
      return {
        size
      };
    }
    return {};
  }, [currentBlock, currentPageUUID]);
  const [pageSettings] = useDocumentContext(customSelector, 'ComlpexArtboardSidebar');
  const { businessLogics } = useContext(BusinessLogic);
  const [fontListVisible, toggleFontList] = useState(false);
  const [isHtmlExpanded,setIsHtmlExpanded]=useState(false);
  const [ activeTabPosY, setActiveTabPosY ] = useState('');
  const [activeTabHeight, setActiveTabHeight] = useState('');
  const scrollRef = useRef(undefined);

  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [CurrentDesign] = useArtboardContext(getCurrentDesign, 'ComplexArtboardSidebar');

  const artboardVersionSelector = useCallback(store => store[CONTEXT_KEYS.ARTBOARD_VERSION], []);
  const [artboardVersion] = useArtboardContext(artboardVersionSelector, 'ComplexArtboardSidebar');

  const previewDownloadSelector = useCallback(store => store[CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD], []);
  const [previewDownloadTab] = useArtboardContext(previewDownloadSelector, 'ComplexArtboardSidebar');

  const tabSelector = useCallback(store => store[CONTEXT_KEYS.TOGGLE_TAB_MENU], []);
  const [toggleTabMenu] = useArtboardContext(tabSelector, 'ComplexArtboardSidebar');

  const  blockTypeSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.REUSABLE_BLOCK_TYPE], []);
  const [reusableBlockType] = useDocumentContext(blockTypeSelector, `ComplexArtboardSidebar`);

  const  documentIdSelector = useCallback(store => store[COMPLEX_DOCUMENT_CONTEXT_KEYS.ID], []);
  const [documentId] = useDocumentContext(documentIdSelector, `ComplexArtboardSidebar`);

  const interactiveDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_INTERACTIVE_DESIGN], []);
  const [isInteractiveDesign] = useArtboardContext(interactiveDesignSelector, `ComplexArtboardSidebar`);

  const isOpenDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_OPEN_DESIGN], []);
  const [isOpenDesign] = useArtboardContext(isOpenDesignSelector, `ComplexArtboardSidebar`);

  const isHybridDesignSelector = useCallback(store => store[CONTEXT_KEYS.IS_HYBRID_MAIL], []);
  const [isHybridDesign] = useArtboardContext(isHybridDesignSelector, `ComplexArtboardSidebar`);

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  const versionSettingsVisibleSelector = useCallback(
    store => store[VERSION_CONTEXT_KEYS.VERSION_FORCE_RENDER],
    [],
  );
  const [versionForceRender, updateVersionStore] = useVersionContext(versionSettingsVisibleSelector);

  const { versionSettingsVisible, readOnly } = useShowVersionSettings(
    `ComplexArtboardSidebar`,
  );
  const [ tabIndex, setTabIndex ] = useState(versionSettingsVisible ? 16 : DEFAULT_TAB_INDEX);

  const currentVersionSelector = useCallback(store => store[VERSION_CONTEXT_KEYS.CURRENT_VISIBLE_VERSION], []);
  const [currentVersion] = useVersionContext(currentVersionSelector, `ComplexArtboardSidebar`);

  const isDesigner = checkUserAccessRoles(userDetails, ['DESIGNER', 'PUBLISHER']);

  let sideBarTabs = isCreativeDesign ? CreativeDesignTabs(t) : ComplexDesignTabs(
    t, 
    CurrentDesign, 
    isInteractiveDesign, 
    isDesigner,
    isOpenDesign,
    currentVersion !== COMPLEX_DOCUMENT_VERSION.DRAFT
  );

  const highLightIndex = sideBarTabs.findIndex(tab => tab.id === tabIndex);

  useEffect(() => {
    if (isHybridDesign) {
      setTabIndex(PREVIEW_AND_DOWNLOAD_TAB);
      updateArtboard({
        [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]: true,
      });
    }
  }, [isHybridDesign]);

  const handleResize = useCallback(() => {
    if(window.innerHeight !== activeTabPosY){
      activeTabPosition(tabIndex);
    }
  }, [activeTabPosY, tabIndex, activeTabPosition]);

  const addElementOnclick = useCallback((clickElement) => {
    updateArtboard({ [CONTEXT_KEYS.ADD_ELEMENT_TO_CREATIVE_BLOCK]: clickElement });
  }, [currentBlock]);

  const activeTabPosition = useCallback((index) => {
    let posY = 0;
    let posHeight = 0;
    if(index !== null && index !== undefined){
      const clientRect = document.querySelector(`#sideBar${index}`)?.getBoundingClientRect();
      posY = index >= 0 ? clientRect?.top : 0;
      posHeight = index >= 0 ? clientRect?.height : 0;
    }
    console.log("change in activeTabPostion :: ", posY);
    setActiveTabPosY(posY);
    setActiveTabHeight(posHeight);
  }, []);

  useEffect(() => {
    if (!hideSideBar) {
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      }
    }
  }, [handleResize, hideSideBar]);

  useEffect(() => {
    requestAnimationFrame(() => activeTabPosition(DEFAULT_TAB_INDEX));
  }, []);

  useEffect(() => {
    if(!versionSettingsVisible && tabIndex === 16) {
      tabClickHandler(-1);
      activeTabPosition(-1);
    }
    if (versionSettingsVisible || readOnly) {
      tabClickHandler(16);
      activeTabPosition(16);
    }
  }, [versionSettingsVisible, versionForceRender, readOnly]);

  const tabClickHandler = useCallback((index) => {
    setIsHtmlExpanded(false)
    if (hideSideBar) {
      if (isCreativeDesign) {
        updateArtboard({
          [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: false,
        });
      } else {
        updateArtboard({
          [CONTEXT_KEYS.BLOCK_SETTINGS_VISIBLE]: false,
          [CONTEXT_KEYS.PAGE_LAYOUT_VISIBLE]: false,
          [CONTEXT_KEYS.ELEMENT_SETTINGS_VISIBLE]: false,
          [CONTEXT_KEYS.SWITCH_CREATIVE_DESIGN_MENU]: false,
          [CONTEXT_KEYS.CURRENT_BLOCK]: ''
        });
      }
    }
    if (index === 10) {
      updateArtboard({
        [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]: true,
      });
    } else if (index === -1) {
      updateArtboard({
        [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]: false,
      });
    }
    if (index === 16 && artboardVersion === COMPLEX_DOCUMENT_VERSION.DRAFT) {
      updateVersionStore({
        [VERSION_CONTEXT_KEYS.VERSION_SETTINGS_VISIBLE]: true,
        [VERSION_CONTEXT_KEYS.VERSION_FORCE_RENDER]: versionForceRender + 1,
      });
    }
    if (index !== 16 && artboardVersion === COMPLEX_DOCUMENT_VERSION.DRAFT) {
      updateVersionStore({
        [VERSION_CONTEXT_KEYS.VERSION_SETTINGS_VISIBLE]: false,
        [VERSION_CONTEXT_KEYS.VERSION_FORCE_RENDER]: versionForceRender + 1,
      });
    }
    toggleFontList(false);
    setTabIndex(oldIndex => {
      return index;
    });
  }, [hideSideBar, isCreativeDesign, artboardVersion]);

  useEffect(() => {
    if (isCreativeDesign) {
      activeTabPosition(DEFAULT_CREATIVE_TAB_INDEX);
      tabClickHandler(DEFAULT_CREATIVE_TAB_INDEX);
      previewDownloadTab &&  tabClosePreviewDownload();
    } else {
      const index = ['header', 'footer'].includes(reusableBlockType) 
        ? DEFAULT_REUSABLE_BLOCK_INDEX 
        : DEFAULT_TAB_INDEX;
      activeTabPosition(index);
      tabClickHandler(index);
    }
  }, [isCreativeDesign]);

  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const { state } = location;
    if(state?.tabIndex) {
      tabClickHandler(parseInt(state.tabIndex));
      setTimeout(() => {
        activeTabPosition(parseInt(state.tabIndex));
      }, 0);    
      history.replace({ tabIndex: undefined });
    }
  }, []);

  useEffect(() => {
    if (!hideSideBar && !fontListVisible) {
      document.getElementById('sidebar-absolute-close').style.visibility = 'hidden';
    } else {
      document.getElementById('sidebar-absolute-close').style.visibility = 'visible';
    }
  }, [hideSideBar, fontListVisible]);

  const onFontToogle = useCallback(() => {
    toggleFontList(prevState => !prevState);
  }, []);

  const scrollToTop = useCallback(() => {
    scrollRef.current.scrollTo(0, 0);
  }, []);

  const renderElement = useCallback((elementObj, isSvg, docElementTab) => {
    return (
      <EditorElement
        element={elementObj}
        isSvg={isSvg}
        clickElement={addElementOnclick}
        toggleDragging={dummyCallback}
        pageSettings={pageSettings}
        setIsDragAndDropped={dummyCallback}
        docElementTab={docElementTab}
        isImage
      />
    )
  }, [pageSettings, addElementOnclick]);

  if (CurrentDesign == TEMPLATE_TYPE.BLOCK) {
    sideBarTabs = sideBarTabs.filter(data => data.id !== 11 && data.id !== 12 && data.id !== 14);
  }
  if (CurrentDesign == TEMPLATE_TYPE.FLOW) {
    sideBarTabs = sideBarTabs.filter(data => data.id !== 11 && data.id !== 14);
  }
  // don't show business logic menu in interactive design if there are no business logics available.
  if (isInteractiveDesign && businessLogics?.length === 0) {
    sideBarTabs = sideBarTabs.filter(v => v.id !== 13);
  }

  if(['header','footer'].includes(reusableBlockType)){
    sideBarTabs = sideBarTabs.filter(data => data.id !== 2);
  }

  useEffect(()=>{
    if(previewDownloadTab){
      activeTabPosition(10);
      tabClickHandler(10);
    }else if(!previewDownloadTab && tabIndex === 10 ){
      activeTabPosition(-1);
      tabClickHandler(-1);
    }
  },[previewDownloadTab]);

  useEffect(() => {
    if (toggleTabMenu?.isOpen) {
      previewDownloadTab && updateArtboard({ [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]: false });
      activeTabPosition(toggleTabMenu.openTabIndex);
      tabClickHandler(toggleTabMenu.openTabIndex);
    } else if(!toggleTabMenu?.isOpen && tabIndex === toggleTabMenu?.openTabIndex){
      activeTabPosition(-1);
      tabClickHandler(-1);
    }
  }, [toggleTabMenu]);

  const tabClosePreviewDownload = ()=>{
    updateArtboard({ [CONTEXT_KEYS.PREVIEW_AND_DOWNLOAD]: false });
  }

  function handleOpenDesign() {
    updateArtboard({
      [CONTEXT_KEYS.SHOW_SIGNUP_PROMPT]: true
    });
  }

  const setDefaultSidebarTab = useCallback(() => {
    activeTabPosition(DEFAULT_TAB_INDEX);
    tabClickHandler(DEFAULT_TAB_INDEX);
  }, [tabClickHandler]);

  return (
    <SidebarMenuWrapper hideDesignSidebar={embedState.hideDesignSidebar}>
      <div style={embedState.hideDesignSidebar ? { display: 'none' } : undefined}>
        <Logo reusableTemplate={['flow', 'block'].includes(CurrentDesign)}>
          <Link   to={ embedState.isEmbedded || isOpenDesign
            ? undefined
            : isInteractiveDesign ? '/interactiveTemplates' : isHybridDesign ? '/hybridMail' :  '/documentTemplates'}>
            <AppLogo>
              <Icon component={DocStudioLogo} />
            </AppLogo>
          </Link>
          <div className="name">
            {t(
              `COMPLEX_DOC_LOGO_HEADER:${COMPLEX_DOC_LOGO_HEADER.DOCUMENT_TITLE.key}`,
              COMPLEX_DOC_LOGO_HEADER.DOCUMENT_TITLE.value,
            )}
          </div>
        </Logo>
        <MenuTabs>
          {!hideSideBar && tabIndex >= 0 && (
            <TabsActivityContainer>
              <TabsActivityHighlighter
                style={{ transform: `translate3d(0px, ${activeTabPosY}px, 0px)`, height: `${activeTabHeight}px` }}
                tabIndex={highLightIndex}
              ></TabsActivityHighlighter>
            </TabsActivityContainer>
          )}
          <TabsContainer>
            {sideBarTabs.map(tab => (
              <TabDetails
                id={`sideBar${tab.id}`}
                onClick={() => {
                  if (isOpenDesign && premiumTabs.includes(tab.id)) {
                    handleOpenDesign();
                  } else {
                    activeTabPosition(tab.id);
                    tabClickHandler(tab.id);
                    if (previewDownloadTab) tabClosePreviewDownload();
                  }
                }}
                active={tabIndex === tab.id}
                key={tab.id}
              >
                <Tooltip placement="right" title={tab.label}>
                  <TabIcon className={tabIndex === tab.id && 'activeTab'}>
                    <Icon
                      component={tab.icon}
                      type={tab.type}
                      className={tab.className}
                      style={{ color: '#fff' }}
                    />
                  </TabIcon>
                </Tooltip>
              </TabDetails>
            ))}
          </TabsContainer>
        </MenuTabs>
      </div>
      <SideBarContent>
        <ComplexDocumentName editable={editable} />
        <TabExpandContainer
          id={`sidebar-absolute-container-version-${artboardVersion}`}
          className={`sidebar-absolute ${tabIndex === 16 && !hideSideBar ? 'showSideBar' : 'hideSideBar'}`}
          versionsTab={currentVersion !== COMPLEX_DOCUMENT_VERSION.DRAFT}
        >
          <SettingsCloseButton id={'sidebar-absolute-close-version'} />
        </TabExpandContainer>
        {!embedState.hideDesignSidebar ? <TabExpandContainer
          ref={scrollRef}
          className={!hideSideBar && tabIndex >= 0 ? 'showSideBar' : 'hideSideBar'}
          longSidebar={tabIndex === 13 || isHtmlExpanded}
          variableSidebar={tabIndex === 10 || tabIndex === 8}
          accessibilitySidebar = {tabIndex === 15}
        >
          {!hideSideBar && tabIndex >= 0 && !fontListVisible && (
            <SidebarCloseMenu onClick={() => {
              tabClickHandler(-1);
              if(versionSettingsVisible) {
                updateVersionStore({
                  [VERSION_CONTEXT_KEYS.VERSION_SETTINGS_VISIBLE]: false,
                  [VERSION_CONTEXT_KEYS.CURRENT_VISIBLE_VERSION]: COMPLEX_DOCUMENT_VERSION.DRAFT
                });
              }
            }}>
              <Tooltip
                placement="right"
                title={t(
                  `DESIGN_AREA_SIDEBAR_MENUS:${DESIGN_AREA_SIDEBAR_MENUS.HIDE_SIDEBAR_TOOLTIP.key}`,
                  DESIGN_AREA_SIDEBAR_MENUS.HIDE_SIDEBAR_TOOLTIP.value,
                )}
              >
                <img src={ExitIcon} alt="exit" />
                <Icon type="left" />
              </Tooltip>
            </SidebarCloseMenu>
          )}
          {!hideSideBar && (
            <TabMenuContainer
              isPreviewTab={tabIndex === 10}
              variableSidebar={tabIndex === 10 || (tabIndex === 8 && CurrentDesign === TEMPLATE_TYPE.DOCUMENT)}
              isAccessibility={tabIndex === 15}
            >
              {tabIndex === 2 && <LetsDesignTabDetails currentDesign={CurrentDesign} />}
              {tabIndex === 3 && (
                <CreativeElementsTabDetails addElementOnclick={addElementOnclick} />
              )}
              {tabIndex === 5 && (
                <UploadsTabDetails ScrollToTop={scrollToTop} renderElement={renderElement} isOpenDesign={isOpenDesign} />
              )}
              {tabIndex === 6 && <MasterElementsTabDetails renderElement={renderElement} currentBlockType={currentBlockType} />}
              {tabIndex === 7 && (
                <ComplexFolderTab template={undefined} CurrentDesign={CurrentDesign} />
              )}
              {tabIndex === 8 && (
                <>
                  {/* New DocumentSettingsTab - used for Documents only */}
                  {CurrentDesign === TEMPLATE_TYPE.DOCUMENT ? (
                    <DocumentSettingsTab
                      CurrentDesign={CurrentDesign}
                      onFontToogle={onFontToogle}
                      fontListVisible={fontListVisible}
                    />
                  ) : (
                    <ComplexSettingsTab
                      template={undefined}
                      CurrentDesign={CurrentDesign}
                      onFontToogle={onFontToogle}
                      fontListVisible={fontListVisible}
                    />
                  )}
                  
                  {/* Original ComplexSettingsTab - commented out for cross-checking */}
                  {/* <ComplexSettingsTab
                    template={undefined}
                    CurrentDesign={CurrentDesign}
                    onFontToogle={onFontToogle}
                    fontListVisible={fontListVisible}
                  /> */}
                </>
              )}
              {tabIndex === 9 && <TranslateTab />}
              <ComplexDocumentVariableList visible={tabIndex === 10} 
                  longSidebar={isHtmlExpanded}
                  editable={editable} 
                  isHtmlExpanded={isHtmlExpanded}
                  setIsHtmlExpanded={setIsHtmlExpanded}/>
              {tabIndex === 11 && <ComplexTemplateTab />}
              {tabIndex === 12 && <ComplexElementsTab />}
              {tabIndex === 13 && <BusinessLogicTab editable={editable} />}
              {tabIndex === 14 && <ChannelTab currentId={documentId} currentType={'document'} />}
              {tabIndex === 15 && (
                <ComplexDocumentAccessibilityValidator template={undefined} CurrentDesign={CurrentDesign} visible={tabIndex === 15} setDefaultSidebarTab={setDefaultSidebarTab} />
              )}
              {tabIndex === 16 && <VersionSettingsSidebar />}
            </TabMenuContainer>
          )}
        </TabExpandContainer> : (
          // When sidebar is hidden, still render ComplexDocumentVariableList (hidden) so event listeners remain active
          <div style={{ display: 'none' }}>
            <ComplexDocumentVariableList 
              visible={false}
              longSidebar={false}
              editable={editable} 
              isHtmlExpanded={false}
              setIsHtmlExpanded={setIsHtmlExpanded}
            />
          </div>
        )}
        <TabExpandContainer
          id={'sidebar-absolute-container'}
          className={`sidebar-absolute ${hideSideBar ? 'showSideBar' : 'hideSideBar'}`}
        >
          <SettingsCloseButton id={'sidebar-absolute-close'} />
        </TabExpandContainer>
      </SideBarContent>
    </SidebarMenuWrapper>
  );
}

export default withTranslation(NAMESPACES)(React.memo(ComplexArtboardSidebar));